import {
	AbsDiagnosticErrorEntity,
	IAbsDiagnosticErrorEntity,
} from '../../core/domain/abs-diagnostic-error.entity';

export enum SubscriptionErrorKey {
	ProfileMissingFields = 'profile-missing-fields',
	NoSelectProfile = 'no-select-profile',
	NoSelectProject = 'no-select-project',
	NoSelectColumnModel = 'no-select-column-model',
	NoSelectFilterModel = 'no-select-filter-model',
	ColumnModelMissingFields = 'column-model-missing-fields',
	ColumnModelExists = 'column-model-exists',
	FilterModelMissingFields = 'filter-model-missing-fields',
	NoSelectColumns = 'no-select-columns',
	NoSelectDatablock = 'no-select-datablock',
	InvalidSubscriptionColumns = 'invalid-subscription-columns',
	InvalidPublicMetadata = 'invalid-public-metadata',
	InvalidInternalMetadata = 'invalid-internal-metadata',
	Unknown = 'unknown',
}

// FIXME: renames file to match class
export class SubscriptionDiagnosticError extends AbsDiagnosticErrorEntity {
	public static build(
		params: Partial<IAbsDiagnosticErrorEntity>
	): SubscriptionDiagnosticError {
		return new SubscriptionDiagnosticError(params);
	}
	public constructor(params: Partial<IAbsDiagnosticErrorEntity>) {
		super(params);
	}
}
